<template>
  <div class="suggestionsList">
    <div>
      <div class="my-suggestionsList">
        <div class="my-banner-tlt font36phone">我的投诉建议</div>
        <div class="my-banner col666666 font24phone">
          <div v-if="myForm.phone">
            <div class="my-banner-submit">
              <div v-if="myForm.supContent==''" class="my-banner-p" style="text-align: right">
                <button class="my-banner-button" @click="addReplyComplaint()">提交</button>
              </div>
              <div class="my-banner-p">
                <span class="my-banner-p-bold">联系手机：{{myForm.phone}}</span>
              </div>
              <div class="my-banner-p">
                <span class="my-banner-p-bold">提交时间：</span>{{$myConvertTimeDetails(myForm.submissionTime)}}
              </div>
              <div class="my-banner-p">
                <span class="my-banner-p-bold">反馈类型：</span>{{myForm.feedbackType}}
              </div>
              <div class="my-banner-p">
                <span class="my-banner-p-bold my-textarea">详细内容：</span>
                <p>{{myForm.details}}</p>
              </div>
              <div class="my-banner-p">
                <span class="my-banner-p-bold my-textarea">补充内容：</span>
                <p v-if="myForm.supContent">{{myForm.supContent}}</p>
                <el-input v-else type="textarea" v-model="toSupContent" maxlength="200" show-word-limit></el-input>
              </div>
            </div>
            <div>
              <div class="my-banner-p" v-show="myForm.replyTime">
                <span class="my-banner-p-bold">回复时间：</span>{{$myConvertTimeDetails(myForm.replyTime)}}
              </div>
              <div class="my-banner-p" v-show="myForm.replyContent">
                <span class="my-banner-p-bold my-textarea">回复内容：</span>
                <p>{{myForm.replyContent}}</p>
              </div>
              <div class="my-banner-p">
                <span class="my-banner-p-bold">反馈结果：</span>
                <span
                  :class="myForm.fbResults?'my-color1':'my-color2'">{{myForm.fbResults?'已回复':'待回复'}}</span>
              </div>
              <div class="my-banner-p" v-show="myForm.supReply">
                <span class="my-banner-p-bold my-textarea">补充回复：</span>
                <p>{{myForm.supReply}}</p>
              </div>
            </div>
          </div>
          <div v-else>
            <p>无历史投诉建议信息！</p>
          </div>
        </div>
        <div :class="prevId?'my-banner-left':'my-banner-right'">
          <a href="javascript:void(0)" class="my-banner-prev overflowText font24phone displayIB" v-show="prevId" @click="getsuggestionsList(prevId)">{{`<上一条 `}}
          </a>
          <a href="javascript:void(0)" class="my-banner-next overflowText font24phone displayIB" v-show="nextId"  @click="getsuggestionsList(nextId)" >下一条></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {$get, $post, } from '@/others/ajax';
import config from '@/others/interface';

export default {
  name: 'suggestionsList',
  props: {
    phone: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      myForm: {
        phone: '',
        submissionTime: '',
        feedbackType: '',
        details: '',
        supContent: '',
        replyTime: '',
        replyContent: '',
        fbResults: false,
        supReply: '',
      },
      nextId: '',
      prevId: '',
      complaintId: '',
      toSupContent: '',
    };
  },
  methods: {
    getsuggestionsList (id) {
      $get(config.zmlgw + '/complaint/complaintH5List', {
        phone: id ? '' : this.phone,
        id: id || '',
      }).then((res) => {
        if (res.code == 200) {
          this.nextId = '';
          this.prevId = '';
          this.complaintId = '';
          this.toSupContent = '';
          this.myForm = {
            phone: '',
            submissionTime: '',
            feedbackType: '',
            details: '',
            supContent: '',
            replyTime: '',
            replyContent: '',
            fbResults: false,
            supReply: '',
          };
          this.nextId = res.data.nextId;
          this.prevId = res.data.prevId;
          this.complaintId = res.data.id;
          this.myForm.phone = res.data.phone;
          this.myForm.feedbackType = res.data.type;
          this.myForm.submissionTime = res.data.contants[0].createdAt;
          this.myForm.details = res.data.contants[0].content;
          if (res.data.contants.length > 1) {
            this.myForm.supContent = res.data.contants[1].content;
          }
          if (res.data.replys) {
            this.myForm.replyTime = res.data.replys[0].createdAt;
            this.myForm.replyContent = res.data.replys[0].content;
            this.myForm.fbResults = true;
            if (res.data.replys.length > 1) {
              this.myForm.supReply = res.data.replys[1].content;
            }
          }
        } else {
          this.$message.error(res.mes);
        }
      });
    },
    addReplyComplaint () {
      if (this.toSupContent.length <= 15) {
        this.$message.error('至少输入15个字');
      } else {
        $post(config.zmlgw + '/complaint/addReplyComplaint', {
          complaintId: this.complaintId,
          content: this.toSupContent,
          type: 2,
        }).then((resAddReply) => {
          if (resAddReply.code == 200) {
            this.$message('感谢反馈！您的参与将帮助我们改进产品及服务。');
            this.toSupContent = '';
            this.getsuggestionsList(this.complaintId);
          } else {
            this.$message(resAddReply.mes);
          }
        });
      }
    },
  },
  mounted () {
    this.getsuggestionsList();
  },
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url("suggestionsList.less");
  }
</style>



// WEBPACK FOOTER //
// suggestionsList.vue